module.exports = __webpack_public_path__ + "img/icon-c-goods.4a070f13.svg";